import { useMemo, type ReactNode } from 'react';

import { FormVariant } from './FormVariant';
import type { NavigateToPathname } from './FormVariant/resolveExitConfig';
import { ProductVariant } from './ProductVariant';
import { resolveHeaderFooterLayoutConfig } from './resolveHeaderFooterLayoutConfig';
import type { HeaderFooterLayoutConfig, HeaderFooterTheme } from './types';

export interface HeaderFooterLayoutProps {
  children: ReactNode;
  layouts: (HeaderFooterLayoutConfig | undefined)[];
  navigate: NavigateToPathname;
  isProd: boolean;
  isWebView: boolean;
  locale: 'no' | 'en';
  onError: (error: unknown) => void;
  defaultExitPath?: string;
  theme?: HeaderFooterTheme;
}

export function HeaderFooterLayout({
  children,
  layouts,
  navigate,
  isProd,
  isWebView,
  locale,
  onError,
  defaultExitPath,
  theme: themeOverride,
}: HeaderFooterLayoutProps) {
  const { variant, theme, exit } = useMemo(
    () => resolveHeaderFooterLayoutConfig(layouts),
    [layouts],
  );
  const resolvedTheme = themeOverride ?? theme;

  return variant === 'product' ? (
    <ProductVariant
      isProd={isProd}
      isWebView={isWebView}
      locale={locale}
      onError={onError}
      theme={resolvedTheme}
    >
      {children}
    </ProductVariant>
  ) : (
    <FormVariant
      defaultExitPath={defaultExitPath}
      exit={exit}
      isProd={isProd}
      isWebView={isWebView}
      locale={locale}
      navigate={navigate}
      onError={onError}
      theme={resolvedTheme}
    >
      {children}
    </FormVariant>
  );
}
